import React from "react";
import otyrobo from "../logos/common/otyrobo.png";
import Typography from "@material-ui/core/Typography";
import * as theme from "../theme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  clientHandOffModalOpened,
  getHelpOrTipText,
  getQFuserMode,
  getShowHelpOrTip,
  goToMarket,
} from "../store/components";
import { useDispatch, useSelector } from "react-redux";
import { Markup } from "interweave";
import { useNavigate } from "react-router-dom";
import SaveAndProceedButton from "../general/SaveAndProceedButton";
import {
  getProspectIdFromQF,
  getProspectDoc,
  getFormState,
  getClientLog,
  openCHSconfirmationModalFun,
  submitChangesForClient,
  handleExpressApplication,
  getExpressApplication,
  handleflashQid,
  implementProductGroupsandQuestions,
  modifyPackage,
  updateAppWithPackage
} from "../store/qf";
import { BROKER, CLIENT } from "../store/businesslogic/hardwiredlogic";
import { updateScratchpad } from "../store/myquotes";
import { Fragment } from "react";
import { TextField, Checkbox, FormControlLabel } from "@material-ui/core";
import { createRemider } from "../store/myreminder";
import { addTransaction } from "../store/transactions";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import { getBrokerageInformation } from "../store/brokerage"
import { getProductList, loadProducts } from "../store/products";
import translations from "../utils/translations";
import { useLocation } from "react-router";
import Popover from "@material-ui/core/Popover";

export default function HelpOrTip(props) {
  const showHelpOrTip = useSelector(getShowHelpOrTip);
  const helpOrTipText = useSelector(getHelpOrTipText);
  const history = useNavigate();

  const widthDist = {
    helpOrTipText: "20%",
    tip: "65%",
    robo: "",
  };
  widthDist.robo = `calc(100% - ${widthDist.helpOrTipText} - ${widthDist.tip})`;

  return (
    showHelpOrTip && (
      <div
        style={{
          height: "100%",
          backgroundColor: theme.COLORS.help_tip,
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            width: widthDist.helpOrTipText,
            height: "100%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {props.hideText ? null : <HelpOrTipText></HelpOrTipText>}
        </div>
        <div
          style={{
            display: "flex",
            width: widthDist.tip,
            height: "100%",
            overflow: "auto",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              //backgroundColor: "pink",

              width: "100%",
            }}
          ></div>
          <div
            color="textSecondary"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: "2vw",
              fontFamily: "GibsonRegular",
              fontSize: "1.8vmin",
              color: "textSecondary",
            }}
          >
            <Markup
              content={
                helpOrTipText
                  ? helpOrTipText
                  : props.defaultText
                  ? props.defaultText
                  : ""
              }
            />
          </div>
          <div
            style={{
              width: "100%",
            }}
          ></div>
        </div>
        <div
          style={{
            width: widthDist.robo,
            display: "flex",
            justifyContent: "center",
            zIndex: 9,
          }}
        >
          {props.hideRobo ? null : <QuoteyBotSVG></QuoteyBotSVG>}
        </div>
      </div>
    )
  );
}

export const QuoteyBotSVG = ({
  st0Fill = "#FFFFFF",
  st1Fill = "#76A7DA",
  st2Fill = "#C6E6F6",
  st3Fill = "#1A4684",
  width = 250,
  height = 250,
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="180 160 360 400"
    xmlSpace="preserve"
    // width={width}
    // height={height}
    // style={{ border: "5px solid black" }}
  >
    <g>
      <path
        fill={st0Fill}
        d="M313.9,273.8h89c21.8,0,39.7,17.9,39.7,39.7v0c0,21.8-17.9,39.7-39.7,39.7h-89c-21.8,0-39.7-17.9-39.7-39.7v0
		C274.1,291.7,292,273.8,313.9,273.8z"
      />
      <g>
        <g>
          <path
            fill={st1Fill}
            d="M359.1,412.4c-0.7,0-1.3-0.1-2-0.1c-55.6,0-104.2,43.8-104.2,105.5l43.7-11.4c5.4,28.8,30.7,50.7,61,50.7
				c0.5,0,1,0,1.5,0V412.4z"
          />
        </g>
        <g>
          <path
            fill={st2Fill}
            d="M359.1,412.4v144.7c29.7-0.7,54.2-22.2,59.5-50.5l46.7,11.2C465.3,459.2,414.4,413.5,359.1,412.4z"
          />
        </g>
      </g>
      <g>
        <path
          fill={st2Fill}
          d="M403.6,236.4H360v27.1h43.6c28.4,0,47.3,21,47.3,49.4c0,28.4-18.9,51.5-47.3,51.5H360v25h43.6
			c43.3,0,76.5-33.2,76.5-76.5C480.1,269.5,446.9,236.4,403.6,236.4z"
        />
      </g>
      <g>
        <path
          fill={st1Fill}
          d="M360,364.4h-43.6c-28.4,0-51.5-23.1-51.5-51.5c0-28.4,23.1-49.4,51.5-49.4H360v-27.1h-43.6
			c-43.3,0-78.6,33.2-78.6,76.5c0,43.3,35.2,76.5,78.6,76.5H360V364.4z"
        />
      </g>
      <g>
        <path
          fill={st3Fill}
          d="M405.7,400.6h-93.1c-46.4,0-84.1-37.7-84.1-84.1v-7.3c0-46.4,37.7-84.1,84.1-84.1h93.1
			c46.4,0,84.1,37.7,84.1,84.1v7.3C489.8,362.9,452,400.6,405.7,400.6z M312.6,237.6c-39.5,0-71.6,32.1-71.6,71.6v7.3
			c0,39.5,32.1,71.6,71.6,71.6h93.1c39.5,0,71.6-32.1,71.6-71.6v-7.3c0-39.5-32.1-71.6-71.6-71.6H312.6z"
        />
      </g>
      <g>
        <path
          fill={st3Fill}
          d="M401.5,364.8h-86.2c-28.3,0-51.2-23-51.2-51.2c0-28.3,23-51.2,51.2-51.2h86.2c28.3,0,51.2,23,51.2,51.2
			C452.7,341.8,429.7,364.8,401.5,364.8z M315.3,274.8c-21.4,0-38.8,17.4-38.8,38.8c0,21.4,17.4,38.8,38.8,38.8h86.2
			c21.4,0,38.8-17.4,38.8-38.8c0-21.4-17.4-38.8-38.8-38.8H315.3z"
        />
      </g>
      <g>
        <circle fill={st3Fill} cx="322.7" cy="313" r="20.1" />
      </g>
      <g>
        <circle fill={st3Fill} cx="358.7" cy="498.6" r="31.6" />
      </g>
      <g>
        <circle fill={st3Fill} cx="399" cy="313.6" r="20.1" />
      </g>
      <g>
        <circle fill={st3Fill} cx="358.8" cy="180.8" r="18" />
      </g>
      <g>
        <rect x="353.2" y="190.3" fill={st3Fill} width="11.3" height="36.8" />
      </g>
      <g>
        <path
          fill={st3Fill}
          d="M233.7,334.8v-42.4c0-2.6,0.7-5.1,1.9-7.3c-1.3-0.3-2.6-0.5-4-0.5c-9.1,0-16.5,7.4-16.5,16.5v25
			c0,9.1,7.4,16.5,16.5,16.5c1.4,0,2.7-0.2,4-0.5C234.4,339.9,233.7,337.4,233.7,334.8z"
        />
      </g>
      <g>
        <path
          fill={st3Fill}
          d="M486.3,334.8v-42.4c0-2.6-0.7-5.1-1.9-7.3c1.3-0.3,2.6-0.5,4-0.5c9.1,0,16.5,7.4,16.5,16.5v25
			c0,9.1-7.4,16.5-16.5,16.5c-1.4,0-2.7-0.2-4-0.5C485.6,339.9,486.3,337.4,486.3,334.8z"
        />
      </g>
      <g>
        <path
          fill={st3Fill}
          d="M358,412.4c-55.6,0-104.2,43.8-104.2,105.5l43.7-11.4c5.4,28.8,30.7,50.7,61,50.7c30.3,0,55.6-21.8,61-50.5
			l46.7,11.2C466.2,458.5,414.1,412.4,358,412.4z M407.6,496.8c0,27.5-22.3,49.8-49.8,49.8s-49.8-22.3-49.8-49.8
			c0-2.2,0.2-4.4,0.4-6.5l-39.4,9.6c6.4-45.5,45.7-76.7,89.9-76.7c44.5,0,86.1,32.6,93.2,76.6l-44.9-9.5
			C407.5,492.4,407.6,494.6,407.6,496.8z"
        />
      </g>
    </g>
  </svg>
);

export const BrokerageLogo = () => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  if (
    BrokerInfo?.brokerageImg?.logo_base64 ||
    BrokerInfo?.brokerageImg?.logo_s3
  ) {
    return (
      <>
        <div
          style={{
            fontFamily: "GibsonRegular",
            fontSize: "1.9vmin",

            color: "rgb(102, 102, 102)",
          }}
        >
          <Typography
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "2.5vmin",
              textAlign: "center",
              color: theme.COLORS.secondary_orange,
            }}
          >
            {translations[languagepreference].yourBrokerInfo}
          </Typography>

          <div
            style={{
              //backgroundColor: "pink",
              height: "10px",
              width: "100%",
            }}
          ></div>
          <div
            color="textSecondary"
            style={{
              fontFamily: "GibsonRegular",
              fontSize: "1.8vmin",
              color: "textSecondary",
              lineHeight: "3vh",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "100%",
              }}
            ></div>

            <p style={{ marginBottom: "0px" }}>
              {BrokerInfo.clientView.firstname +
                " " +
                BrokerInfo.clientView.lastname}
            </p>
            <p style={{ marginBottom: "0px" }}>
              {BrokerInfo.clientView.user?.email}
            </p>
            <p>{BrokerInfo.clientView.phonenumber}</p>
          </div>
        </div>

        <img
          style={{ alignSelf: "center", height: "24%" }}
          src={
            BrokerInfo?.brokerageImg?.logo_s3
              ? BrokerInfo.brokerageImg.logo_s3.Location
              : "data:image/png;base64," + BrokerInfo?.brokerageImg?.logo_base64
          }
          alt="Brokerage Img"
        />
      </>
    );
  }
  return null;
};

const HelpOrTipText = () => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  let text = translations[languagepreference].helpOrTipFromQuotey;
  const qfUserMode = useSelector(getQFuserMode);
  text =
    qfUserMode == CLIENT
      ? translations[languagepreference].helpOrTip
      : translations[languagepreference].helpOrTipFromQuotey;
  return (
    <Typography
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "2.5vmin",
        color: theme.COLORS.secondary_orange,
      }}
    >
      {text}
    </Typography>
  );
};

export function VerticalHelpOrTip(props) {
  const helpOrTipText = useSelector(getHelpOrTipText);
  const prospectId = useSelector(getProspectIdFromQF);
  const qfUserMode = useSelector(getQFuserMode);
  const isExpressApplication = useSelector(getExpressApplication);
  const history = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const searchquery = new URLSearchParams(search);
  const [initialScratchPad, setinitialScratchPad] = React.useState("");
  const handleBlur = (e) => {
    let updateData = { ...props };
    updateData.scratchpad = e.target.value;
    dispatch(updateScratchpad(updateData));
  };
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation.information.languagepreference;
  let bkgInformation = useSelector(getBrokerageInformation);
  const ExpressApplicationText = isExpressApplication
    ? translations[languagepreference].fullApplication
    : translations[languagepreference].turboApplication;
  const PkgMoreCvgTxt = translations[languagepreference].coveragePopOverHeader;
  const gotProspectDetails = useSelector(getProspectDoc);
  const gotProspectFormState = useSelector(getFormState);
  const [anchorEl, setAnchorEl] = React.useState(null);
  React.useEffect(() => {
    if (gotProspectDetails.scratchpad) {
      setinitialScratchPad(gotProspectDetails.scratchpad);
    }
    dispatch(retrieveBrokerageImg(gotProspectDetails.brokeragecode));
    dispatch(retrieveBrokerforClient(gotProspectDetails.userid));
    dispatch(loadProducts());
    if (searchquery?.get("isExpressApp") == "true" && qfUserMode == CLIENT) {
      dispatch(handleExpressApplication());
    }
  }, []);

  React.useEffect(() => {
    if (qfUserMode === BROKER && !Array.isArray(bkgInformation)) {
      if (!bkgInformation.isfullapp) {
        dispatch(handleExpressApplication());
      }
    }
  }, [bkgInformation?.isfullapp, qfUserMode]);
  const onChangeHandler = (event) => {
    setinitialScratchPad(event.target.value);
  };
  const clientLog = useSelector(getClientLog);
  const heightDist = {
    top: "40%",
    helpText: "30%",
    remaining: "",
  };
  heightDist.remaining = `calc(100% - ${heightDist.top} - ${heightDist.helpText})`;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        //        backgroundColor: "pink",
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.COLORS.tertiary_lightbackground,
      }}
    >
      <div
        style={{
          width: "100%",
          height: heightDist.top,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "70%",
            paddingBottom: 25,
            paddingTop: 15,
            flexDirection: "column",
          }}
        >
          {qfUserMode === BROKER ? (
            <Fragment>
              {/* <SaveAndProceedButton
                text={translations[languagepreference].goBackToCustomer}
                display={
                  !gotProspectDetails.otherdetails?.customerid ? "none" : null
                }
                onClick={() => {
                  history(
                    `/customer?id=${gotProspectDetails.otherdetails?.customerid}`
                  );
                }}
              ></SaveAndProceedButton> */}
              <div style={{ width: "100%", height: "6%" }}></div>
              <SaveAndProceedButton
                text={translations[languagepreference].goToMarket}
                onClick={() => {
                  dispatch(goToMarket());
                  //document.location.href = `/quotes?id=${prospectId}`;
                  //history(`/quotes?id=${prospectId}`);
                }}
              ></SaveAndProceedButton>
              <div style={{ width: "100%", height: "6%" }}></div>

              <SaveAndProceedButton
                text={translations[languagepreference].handOffToClient}
                onClick={() => {
                  dispatch(clientHandOffModalOpened());
                }}
              ></SaveAndProceedButton>
              <div style={{ width: "100%", height: "6%" }}></div>

              <SaveAndProceedButton
                text={ExpressApplicationText}
                onClick={() => {
                  dispatch(handleExpressApplication());
                }}
              ></SaveAndProceedButton>
              <div style={{ width: "100%", height: "6%" }}></div>
              <SaveAndProceedButton
                text={translations[languagepreference].coveragePopOverHeader}
                onClick={(event) => {
                  //dispatch(handleExpressApplication());
                  setAnchorEl(event.currentTarget);
                }}
              >   
              </SaveAndProceedButton>
              <ProductPackagePopOver 
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  gotProspectDetails={gotProspectDetails}
                  languagepreference={languagepreference}
                />
            </Fragment>
          ) : null}

          {qfUserMode === CLIENT ? (
            <Fragment>
              <SaveAndProceedButton
                text={translations[languagepreference].imDoneAnswering}
                disabled={!clientLog || clientLog?.length == 0}
                onClick={async () => {
                  if (!clientLog || clientLog?.length == 0) {
                    console.log("No changes made");
                    return;
                  }
                  //document.location.href = `/thanksforanswers`;
                  dispatch(openCHSconfirmationModalFun(true));
                  var reminder_data = {
                    title: "Client finished Answering",
                    description: "Please review client changes",
                    ownertype: "individual",
                    owner: gotProspectDetails.userid,
                    creator: gotProspectDetails.userid,
                    remindertype: "prospect",
                    clientid: null,
                    policyid: null,
                    prospectid: gotProspectDetails._id,
                    remindercategory: "cat-2",
                    reminderdate: new Date().toJSON(),
                    archive: false,
                    deleted: false,
                    brokeragecode: gotProspectDetails.brokeragecode,
                    //"sendemail": true
                  };
                  let transaction_data = {
                    prospectid: gotProspectDetails._id,
                    fromstatus: "Client adjustments",
                    tostatus: "Client adjustments",
                    comments:
                      "Please review client changes during client hand-off",
                    otherDetails: { clientLog: clientLog },
                    usertime: new Date(),
                  };
                  await dispatch(
                    submitChangesForClient({ transaction_data, reminder_data })
                  );
                  //history.push( `/thanksforanswers`);
                }}
              ></SaveAndProceedButton>
            </Fragment>
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            width: "100%",
            height: "30%",
            paddingBottom: 25,
          }}
        >
          <HelpOrTipText></HelpOrTipText>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: heightDist.helpText,
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            //      backgroundColor: "yellow",
            paddingLeft: "2vw",
            paddingRight: "1vw",
            overflow: "auto",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "GibsonRegular",
            fontSize: 15,
            lineHeight: 1.4,
          }}
        >
          <Markup
            content={
              helpOrTipText
                ? helpOrTipText
                : props.defaultText
                ? props.defaultText
                : ""
            }
          />
        </div>
      </div>
      {qfUserMode === BROKER ? (
        <>
          <TextField
            style={{
              width: "83%",
              marginRight: "1vw",
              marginLeft: "2vw",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              margin: "auto",
              borderRadius: "8px",
              paddingLeft: "1vw",
            }}
            value={initialScratchPad}
            placeholder={translations[languagepreference].scratchpad}
            multiline
            minRows={2}
            maxRows={6}
            onBlur={handleBlur}
            onChange={onChangeHandler}
          />
          <div
            style={{
              width: "100%",
              height: "15%",
              //    backgroundColor: "lightgrey",
              display: "none", //"flex",
              justifyContent: "center",
            }}
          >
            <QuoteyBotSVG></QuoteyBotSVG>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              //backgroundColor: "pink",
              height: "20vh",
              width: "100%",
            }}
          ></div>
          <BrokerageLogo></BrokerageLogo>
        </>
      )}
    </div>
  );
}

const ProductPackagePopOver = ({anchorEl, setAnchorEl, gotProspectDetails, languagepreference}) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const productList = useSelector(getProductList)
  let selectedverticalid = gotProspectDetails?.answers?.selectedverticalid
  let filteredOptions = productList
    .filter((item) =>
      item.package.some((pkg) => pkg.operationlist?.includes(selectedverticalid)) ||
      item.packageonly.includes(selectedverticalid)
    )
    .map((item) => ({
      id: item._id,
      label: item.name[languagepreference],
      checked: item.selected,
      description: item.description[languagepreference],
    }));

  let packageDetails = gotProspectDetails.otherdetails?.triagedata?.packageDetails
  React.useEffect(() => {
     
    //console.log("packageDetails: ", packageDetails)
    if(!packageDetails) return;
    filteredOptions = productList
        .filter((item) =>
          item.package.some((pkg) => pkg.operationlist?.includes(selectedverticalid)) ||
          item.packageonly.includes(selectedverticalid) ||
          ( item.code == 'Property' ) // && Object.keys(item.otherinfo.verticalproductmap).includes(selectedverticalid) 
        )
        .map((item) => ({
          id: item.code,
          label: item.name[languagepreference],
          checked: packageDetails[item.code] == 'Package',
          description: item.description[languagepreference],
        }));
    setOptions(filteredOptions)
    
  }, [productList, selectedverticalid, packageDetails,languagepreference])


  //console.log("filteredOptions ", filteredOptions)
  //console.log("selectedverticalid: ", selectedverticalid);
  let example = [
    { id: 'option1', label: 'Option 1', checked: false },
    { id: 'option2', label: 'Option 2', checked: false },
    { id: 'option3', label: 'Option 3', checked: false },
  ]
  const [options, setOptions] = React.useState(filteredOptions);

  const handleCheckboxChange = (optionId) => (event) => {
    const checked = event.target.checked;
    // setOptions((prev) =>
    //   prev.map((option) =>
    //     option.id === optionId ? { ...option, checked } : option
    //   )
    // );
    //console.log(`Checkbox ${optionId} is now:`, checked ? 'Checked' : 'Unchecked');
    let product = productList.find(x => x.code == optionId)
    let directive = product.package.find(x => x.operationlist.includes(selectedverticalid)) || {};
    if(product.otherinfo.verticalproductmap){
      directive.addforms = [product.otherinfo.verticalproductmap[selectedverticalid]];
    }
    //console.log("product: ", product);

    let triagedata = gotProspectDetails.otherdetails.triagedata;
    let type = checked ? 'add' : 'remove';
    dispatch(updateAppWithPackage({...directive, type, productid:optionId }))
    
    //dispatch(implementProductGroupsandQuestions({...directive, type, productid:optionId }))
    
    // if(checked){
    //   //add questions

    //   console.log(directive)
    //   console.log(gotProspectDetails.otherdetails.triagedata)
    //   // triagedata.packageDetails[optionId] = 'Package';
    //   // triagedata.addQuestions.push(...directive.addquestions);
    //   // console.log("triagedata: ", triagedata)
     
    //   //dispatch(modifyPackage(directive, "add"))

    // }else{
    //   // remove questions
    //   dispatch(implementProductGroupsandQuestions({...directive, type:'remove', productid:optionId }))

    // }
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={() => {
        setAnchorEl(null)
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          padding: "1em",
        },
      }}
      // classes={classes}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div className="popover-header" style={{'backgroundColor': '#F2F2F2', padding: '0.5em 1em', textAlign: 'center'}}>
        <Typography variant="subtitle1" gutterBottom style={{ fontFamily: 'Arial, sans-serif', fontSize: '1.5em', fontWeight: 'bold', color: '#333' }}>
          {translations[languagepreference].coveragePopOverHeader}
        </Typography>
      </div>
      <div
        className="popover-content"
        style={{
          maxWidth: "400px",
          maxHeight: "800px",
          overflowX: "hidden",
          display:"flex",
          flexDirection:"column",
          // backgroundColor:""
        }}
      >
        <p style={{ margin: '0 auto', maxWidth: '80%', color: '#666', textAlign:"center",  }}>  {translations[languagepreference].coveragePopOverDescription} </p>
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            control={
              <Checkbox
                checked={option.checked}
                onChange={handleCheckboxChange(option.id)}
                color="primary"
              />
            }
            label={option.label}
          />
        ))}
        
      </div>
    </Popover>
  )
} 